import React, {useEffect} from 'react';
import {Route, Routes} from 'react-router-dom';
import ProductPerformance from './features/ProductPerformance/ProductPerformance';
import NavbarLayout from './layouts/navbar/NavbarLayout';
import {
    ABOUT_INFLUIO,
    ADMIN_PAID_PROJECTS,
    ADVERTISER_MANAGEMENT,
    AFFILIATE_PERFORMANCE,
    AI_CHAT_ASSISTANT,
    AI_GROUP,
    AI_INFLUENCER_REVENUES,
    APP_USER_LOGIN,
    ASSIGN_INFLUENCERS,
    BRAND_INFLUENCER_REPORTS,
    CREATE_CAMPAIGN,
    CREATE_PAID_PROJECT,
    CREATE_PROMO_CODE,
    CUSTOM_PAGE,
    EDIT_PROJECT,
    EXCEL_CONVERSIONS_REJECTED,
    HANDLE_MISSING_OLD_HTML_PAGES,
    HOME,
    INFLUENCER_CHATS,
    INSERT_INFLUENCERS,
    INTEGRATIONS_HELPER,
    KARACA_NEW_PARTNERS,
    KARACA_USER_NEW_REGISTRATION,
    LCW_LANDING_PAGE_URL,
    LCW_NEW_PARTNERS,
    LCW_USER_NEW_REGISTRATION,
    LOGIN, MLINK,
    NANO_PROJECTS,
    PURCHASE_REPORTS,
    SIGN_UP,
    STATUS_CENTER,
    USER_BANK_SETTINGS_UPDATE,
    USER_PAYMENTS,
    USER_SETTINGS_UPDATE,
    USERS_ADMIN,
    USERS_ADMIN_LIST
} from './common/constants/routes';
import Spinner from "./common/spinner/Spinner";
import {usePromiseTracker} from "react-promise-tracker";
import './common/styles/global.scss'
import Home from "./features/Home/Home";

import PrivateRoutes from "./features/login/PrivateRoutes";
import Login from "./features/login/Login";
import {CssBaseline} from "@mui/material";
import SignUp from "./features/signUp/SignUp";
import {useDispatch} from "react-redux";
import {getSession} from "./store/auth/authActions";
import AffiliatePerformances from "./features/AffiliatePerformances/AffiliatePerformances";
import UsersAdmin from "./features/UsersAdmin/UsersAdmin";
import UserSettingsUpdate from "./forms/UserSettingsUpdate/UserSettingsUpdate";
import UserBankDetailsUpdate from "./forms/UserBankDetailsUpdate/UserBankDetailsUpdate";
import LcwNewPartners from "./features/LcwNewPartners/LcwNewPartners";
import LcwLandingPage from "./features/LcwLandingPage/LcwLangingPage";
import AboutInfluio from "./features/AboutInfluio/AboutInfluio";
import LCWUserRegistration from "./forms/LCWUserRegistration/LCWUserRegistration";
import IntegrationHelper from "./features/IntegrationHelper/IntegrationHelper";
import CreatePromoCode from "./features/AdvertiserManagement/CreatePromoCode/CreatePromoCode";
import CreateCampaign from "./features/AdvertiserManagement/CreateCampaign/CreateCampaign";
import StatusCenter from "./features/AdvertiserManagement/StatusCenter/StatusCenter";
import CreateEditPaidProject from "./features/AdvertiserManagement/CreateEditPaidProject/CreateEditPaidProject";
import PaidProjects from "./features/PaidProjects/PaidProjects";
import AssignInfluencers from "./features/PaidProjects/AssignInfluencers/AssignInfluencers";
import EditProject from "./features/PaidProjects/EditProject/EditProject";
import AppUserLogin from "./features/AppUserLogin/AppUserLogin";
import UserPayments from "./features/UserPayments/UserPayments";
import AiRadar from "./features/AiRadar/AiRadar";
import InfluencerChats from "./features/InfluencerChats/InfluencerChats";
import InsertInfluencers from "./features/InsertInfluencers/InsertInfluencers";
import AIInfluencerRevenues from "./features/AIInfluencerRevenues/AIInfluencerRevenues";
import CreateHtmlTemplate from "./features/CreateHtmlTemplate/CreateHtmlTemplate";
import CustomPageTemplate from "./features/CustomPageTemplate/CustomPageTemplate";
import BrandsInfluencersReports from "./features/BrandsInfluencersReports/BrandsInfluencersReports";
import KaracaUserRegistration from "./forms/KaracaUserRegistration/KaracaUserRegistration";
import KaracaNewPartners from "./features/KaracaNewPartners/KaracaNewPartners";
import UploadConversionFormatExcel from "./features/UploadConversionFormatExcel/UploadConversionFormatExcel";
import MLinkIntegration from "./features/MLinkIntegration/MLinkIntegration";

function App() {

    const {promiseInProgress} = usePromiseTracker();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getSession());
    }, [dispatch])

    return (
        <>
            <CssBaseline/>
            <Routes>
                <Route element={<PrivateRoutes/>}>
                    <Route path='/' element={<NavbarLayout/>}>
                        <Route path={HOME} element={<Home/>}/>
                        <Route path={PURCHASE_REPORTS} element={<ProductPerformance/>}/>
                        <Route path={INTEGRATIONS_HELPER} element={<IntegrationHelper/>}/>
                        <Route path={NANO_PROJECTS+LCW_NEW_PARTNERS} element={<LcwNewPartners/>}/>
                        <Route path={NANO_PROJECTS+KARACA_NEW_PARTNERS} element={<KaracaNewPartners/>}/>
                        <Route path={BRAND_INFLUENCER_REPORTS} element={<BrandsInfluencersReports/>}/>
                        <Route path={USERS_ADMIN + USERS_ADMIN_LIST} element={<UsersAdmin/>}/>
                        <Route path={USERS_ADMIN + SIGN_UP} element={<SignUp/>}/>
                        <Route path={USERS_ADMIN + USER_PAYMENTS} element={<UserPayments/>}/>
                        <Route path={USERS_ADMIN + AFFILIATE_PERFORMANCE} element={<AffiliatePerformances/>}/>
                        <Route path={USERS_ADMIN + HANDLE_MISSING_OLD_HTML_PAGES} element={<CreateHtmlTemplate/>}/>
                        <Route path={USERS_ADMIN + EXCEL_CONVERSIONS_REJECTED} element={<UploadConversionFormatExcel/>}/>
                        <Route path={AI_GROUP + AI_CHAT_ASSISTANT} element={<AiRadar/>}/>
                        <Route path={AI_GROUP + AI_INFLUENCER_REVENUES} element={<AIInfluencerRevenues/>}/>
                        <Route path={AI_GROUP + INSERT_INFLUENCERS} element={<InsertInfluencers/>}/>
                        <Route path={AI_GROUP + INFLUENCER_CHATS} element={<InfluencerChats/>}/>
                        <Route path={MLINK} element={<MLinkIntegration/>}/>
                        <Route path={ADMIN_PAID_PROJECTS} element={<PaidProjects/>}/>
                        <Route path={ADMIN_PAID_PROJECTS + ASSIGN_INFLUENCERS} element={<AssignInfluencers/>}/>
                        <Route path={ADMIN_PAID_PROJECTS + EDIT_PROJECT} element={<EditProject/>}/>
                        <Route path={ADVERTISER_MANAGEMENT + CREATE_CAMPAIGN}
                               element={<CreateCampaign/>}/>
                        <Route path={ADVERTISER_MANAGEMENT + CREATE_PROMO_CODE}
                               element={<CreatePromoCode/>}/>
                        <Route path={ADVERTISER_MANAGEMENT + CREATE_PAID_PROJECT}
                               element={<CreateEditPaidProject/>}/>
                        <Route path={ADVERTISER_MANAGEMENT + STATUS_CENTER}
                               element={<StatusCenter/>}/>
                    </Route>
                </Route>
                <Route path={LOGIN} element={<Login/>}/>
                <Route path={APP_USER_LOGIN} element={<AppUserLogin/>}/>
                <Route path={USER_SETTINGS_UPDATE} element={<UserSettingsUpdate/>}/>
                <Route path={USER_BANK_SETTINGS_UPDATE} element={<UserBankDetailsUpdate/>}/>
                <Route path={LCW_USER_NEW_REGISTRATION} element={<LCWUserRegistration/>}/>
                <Route path={KARACA_USER_NEW_REGISTRATION} element={<KaracaUserRegistration/>}/>
                <Route path={LCW_LANDING_PAGE_URL} element={<LcwLandingPage/>}/>
                <Route path={ABOUT_INFLUIO} element={<AboutInfluio/>}/>
                <Route path={CUSTOM_PAGE} element={<CustomPageTemplate/>}/>

            </Routes>
            {!!promiseInProgress && <Spinner/>}
        </>
    );
}

export default App;
